<template>
    <drawer title="Create a new folder" class="flex-create-folder">
        <div class="page-data__container">
            <div v-if="isSaving">
                <loading-component />
            </div>
            <template v-else>
                <section>
                    <h2 class="flex-form__section-title">
                        Folder Name
                    </h2>

                    <label class="flex-form__field">
                        <div class="flex-form__label">
                            Folder Name
                        </div>

                        <input
                            v-model="name"
                            class="flex-form__input"
                            type="text"
                        >
                    </label>

                    <button
                        class="flex-page-data__button flex-page-data__button--continue"
                        @click="createFolder"
                    >
                        CREATE
                    </button>

                    <button
                        class="flex-page-data__button flex-page-data__button--cancel"
                        @click="hideDrawer"
                    >
                        CANCEL
                    </button>
                </section>
            </template>
        </div>
    </drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import LoadingComponent from '@/components/shared/loading/loading-component';
import Drawer from '@/components/shared/drawer/drawer';
import * as service from '@/sitecore/sitecore-data-service';
import { HIDE_DRAWER, SHOW_ALERT, SHOW_DRAWER } from '@/store/types/mutation-types';

export default {
    components: {
        Drawer,
        LoadingComponent,
    },

    data() {
        return {
            isSaving: false,
            showNav: true,
            name: 'New Folder',
        };
    },

    computed: {
        ...mapState({
            newPagePath: ({ page }) => page.newPagePath,
        }),
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            setErrorMessage: SHOW_ALERT,
            showDrawer: SHOW_DRAWER,
        }),

        async createFolder() {
            if (!this.validInput()) {
                return;
            }
            this.isSaving = true;
            const itemData = { path: this.newPagePath, name: this.name };
            const response = await service.createFolder(itemData);
            if (response.status === 'error') {
                this.isSaving = false;
                return;
            }
            this.isSaving = false;

            this.hideDrawer();
            await this.$nextTick();
            this.showDrawer({
                componentTag: 'navigation-tree-content',
                data: {
                    id: response.data,
                },
            });
        },

        validInput() {
            if (!this.name) {
                this.setErrorMessage({ description: 'Name value is required' });
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.flex-create-folder {
    overflow-y: auto;

    .page-data {
        &__container {
            min-width: 100%;
            height: calc(100vh - #{ $drawer-header-height } - 50px); // 50px = height of buttons on bottom
            overflow-y: auto;
            margin: 24px;
        }

        &__back {
            margin: 25px 35px 0 35px;
            color: var(--form-buttonBackgroundColor);
        }
    }

    .flex-page-data__button {
        margin-right: 15px;
    }
}
</style>
